import type { Scope } from "@amzn/ads-discovery-theme-service-typescript-client";

import { SearchSortAttribute } from "../api/adsApi/adsApi.interfaces";
import { IHubContentType } from "../types/ihubContentType";
import { IHubContentProvider, InsightFamilyName } from "../types/providers";

export const STANDALONE_INSIGHTS = "Standalone insights";
export const PACKAGED_INSIGHTS = "Packaged insights";
export const PRE_PACKAGED_INSIGHTS = "Pre-packaged insights";
export const CUSTOM_INSIGHTS = "Custom insights";
export const MARKETING_NARRATIVES = "Marketing narratives";
export const ALL_FAMILIES = "All";
export const ALL_PACKAGED = "All Packaged Insights";
export const ALL_FILTER_LABEL = "All";
export const NONE_SELECTED_FILTER_LABEL = "Any";

export const IHubContentTypeToLabelMap = {
    [IHubContentType.INSIGHTS]: "Insights",
    [IHubContentType.MARKETING_CONTENT]: "Marketing content",
};

export const InsightFamilyNameToLabelMap = {
    ALL_FAMILIES: "All Standalone Insights",
    [InsightFamilyName.AUDIENCE_FUNNEL_SIZING]: "Audience funnel",
    [InsightFamilyName.BRAND_LOYALTY]: "Audience insights",
    [InsightFamilyName.BRANDED_SEARCH_TRENDS]: "Branded search trends",
    [InsightFamilyName.NEW_TO_BRAND]: "New to brand",
    [InsightFamilyName.PATH_TO_PURCHASE]: "Path to purchase",
    [InsightFamilyName.PEER_BENCHMARKING]: "Peer benchmarking",
    [InsightFamilyName.PEER_BENCHMARKING_UAT]: "Peer benchmarking UAT",
    [InsightFamilyName.BRAND_LOYALTY_UAT]: "Brand loyalty UAT",
    [InsightFamilyName.REPEAT_PURCHASER]: "Repeat purchaser",
    [InsightFamilyName.SHARE_OF_VOICE]: "Share of voice",
    [InsightFamilyName.INSIGHT_GENIE]: "A&I Insights",
};

export const MARKETING_NARRATIVES_CATEGORY_DELIMINITER = "|";

export const IHubContentProviderToSortAttributeMap = {
    [IHubContentProvider.MARKETING_NARRATIVES]: [
        {
            value: SearchSortAttribute.LAST_MODIFIED_DATE,
            label: "Last modified date",
        },
        {
            value: SearchSortAttribute.RELEVANCY,
            label: "Relevancy",
        },
        {
            value: SearchSortAttribute.VIEWS_AND_DOWNLOADS,
            label: "Views and downloads",
        },
    ],
};

// TO-DO: move to filter.json in theme service
export const scopeToTooltipMap = {
    // Insights
    All: "Insights across all families",
    AllPackaged: "Insights across all pre-packaged types",
    AudienceFunnelSizing:
        "Audience funnel insights from APT (Quarterly Conversion Rates, Yearly Funnel Size)",
    BrandLoyalty:
        "AIP insights (NewToBrand, LongTimeValue, Order Distribution For Day of Week)",
    BrandedSearchTrends: "Weekly and Monthly Brand Search trends from NABS",
    NewToBrand: "",
    PathToPurchase: "Shopper journey from browsing to purchase from P2P",
    PeerBenchmarking:
        "Insights from Peer Scorecard (e.g. YTD Ad spend Peer Comparision, Investment Allocation by ad product Peer Comparision)",
    RepeatPurchaser: "",
    ShareOfVoice:
        "Insights from BSI (e.g. Branded keywords SOV, Peer set branded keywords, Ad Spend Correlation)",
    CAIRE: "Advertiser specific insight based recommendations (OOB, keywords, Core 4)",
    [InsightFamilyName.INSIGHT_GENIE]: "A&I insights modules created by AIPs",
    SEASONAL_EVENT:
        "Packaged insights for seasonal events (e.g. Prime day, BFCM, Tentpole event recap)",
    "Ad Products":
        "Packaged insights for Ad Products (e.g. AMC SIP, PVa, TNF, Path to Conversion, Advertising metrics Review, Campaign audience overlap)",
    "Advertiser Goals":
        "Goal based packaged insights (e.g. BGF, New product launch)",
    "Downstream Impact":
        "New to Brand, ASIN level targeting, Repeat Purchase, Annualized Customer value, ASIN level sales performance",
    "Industry Insights":
        "Industry specific trends (e.g. ACI, Industry quarterly trends, Insight case studies)",
    "Seasonal Events":
        "Packaged insights for seasonal events (e.g. Prime day, BFCM, Tentpole event recap)",
    // Marketing Narratives
    "18d0e2d6-bbf9-4346-b6ea-6a21a977b52f":
        "Sales presentation to persuade audience  to adopt an Amazon Ads product or service",
    "efb3438d-cb13-4695-9774-16cbed61f0b4":
        "A One-pager highlighting an advertiser success using Amazon Ad products",
    "952d9654-2a8d-4a5a-a1ac-c66d3ec84f20":
        "Content used to advise the audience how to do something (ex. Creative Best Practices guide)",
    "7dd4cf1d-825d-4090-91b5-196c4bbc4c34": "Learning white paper",
    "31f2eb16-69bc-49f4-9118-963c4ab0f1da":
        "A Single document that summarizes a product or concept",
    "18fc2134-0df1-4566-ad35-68b318e2ef22": "Amazon Ads powerpoint templates",
    "e81f2681-41a7-4393-a2ed-fa7d56bc7b03":
        "A Product handout that includes key information such as description, availability, audience, placement",
    "f9e4326e-e57b-4711-99af-5d5d8d74741f":
        "A Series of supplemental slides to provide updates across the business, including recent news from Amazon’s corporate blog, new insights, product updates, etc.",
    "b0e50e0e-afb8-4fef-a4d3-39b639503bfe": "Content that teaches a skill",
};

export const allPackagedInsightScope: Scope = {
    label: ALL_PACKAGED,
    value: "AllPackaged",
    disabled: false,
};
